import { useI18n } from "@/lib/i18n";
import { IMAGES } from "@/lib/images";
import { SERVICE_LANGS } from "@/lib/fleet";
import { Reveal, SectionHead } from "./Reveal";

export const Standards = () => {
  const { t } = useI18n();
  return (
    <>
      <section className="bg-[#0D0E11] border-y border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-36 grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="relative">
                <img src={IMAGES.chauffeur} alt="Chauffeur standard" className="w-full aspect-[3/4] object-cover" />
                <div className="absolute inset-0 border border-[var(--elt-line)] m-4 pointer-events-none" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <SectionHead eyebrow={t("chauffeur.eyebrow")} title={t("chauffeur.title")} />
            <Reveal delay={0.15}>
              <p className="mt-6 text-sm font-light text-[var(--elt-muted)] max-w-lg leading-relaxed">{t("chauffeur.body")}</p>
              <div className="mt-10 grid sm:grid-cols-2 gap-x-10 gap-y-3">
                {t("chauffeur.standards").map((s) => (
                  <div key={s} className="flex items-center gap-3 text-sm font-light text-[var(--elt-ivory)]/85 py-1.5 border-b border-white/5">
                    <span className="w-4 h-px bg-[var(--elt-gold)] shrink-0" />{s}
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-6">
            <SectionHead eyebrow={t("discretion.eyebrow")} title={t("discretion.title")} />
            <Reveal delay={0.12}>
              <p className="mt-6 text-sm font-light text-[var(--elt-muted)] max-w-md leading-relaxed">{t("discretion.body")}</p>
              <div className="mt-8 flex flex-wrap gap-2">
                {t("discretion.items").map((s) => (
                  <span key={s} className="text-[0.65rem] tracking-[0.2em] uppercase text-[var(--elt-ivory)]/70 border border-white/10 px-4 py-2">{s}</span>
                ))}
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex flex-col justify-center">
            <Reveal delay={0.2}>
              <p className="font-serif-elt text-2xl md:text-3xl font-light leading-snug text-[var(--elt-gold-light)]">{t("discretion.statement")}</p>
              <div className="mt-12 pt-10 border-t border-[var(--elt-line)]">
                <p className="eyebrow mb-4">{t("misc.yourLanguage")}</p>
                <p className="text-sm font-light text-[var(--elt-muted)] mb-4">{t("misc.langBody")}</p>
                <p className="font-serif-elt text-lg font-light text-[var(--elt-ivory)]/90 leading-loose">{SERVICE_LANGS.join("  ·  ")}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};
